import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/AppSidebar';
import FaqWidget from '@/components/FaqWidget';
import { PortalCountdownBanner } from '@/components/PortalCountdownBanner';
import Footer from '@/components/Footer';

export default function DashboardLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full flex-col">
        <div className="flex flex-1 min-h-0">
          <AppSidebar />
          <div className="flex-1 flex flex-col min-w-0">
            <div className="sticky top-0 z-30">
              <header className="h-14 flex items-center border-b bg-card/50 backdrop-blur-sm px-4">
                <SidebarTrigger className="mr-4" />
                <div className="flex-1" />
              </header>
              <PortalCountdownBanner />
            </div>
            <main className="flex-1 p-4 md:p-6 lg:p-8 mb-16">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
      <Footer className="fixed bottom-0 left-0 right-0 pl-[--sidebar-width]" />
      {/* Persistent FAQ help button — visible on every authenticated page */}
      <FaqWidget />
    </SidebarProvider>
  );
}
